import axios from "axios";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useState, useEffect } from "react";

import { TextField,Button } from '@mui/material';

function PeerAssignment2(props) {
    //I need to load up all the companies and then only show the companies that don't have a peer assignment
    const [allCompanies, setAllCompanies] = useState([{}]);
    const [selectedCompany, setSelectedCompany] = useState(0);
    useEffect(() => {
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL + 'company',
            method: "GET",
            data: {},
            headers: {
                // Add any auth token here
                //authorization: "your token comes here",
            },
        }).then((res) => {
            setAllCompanies(res.data);
        }).catch((err) => {
            console.log(err)
        });
    }, [props.selectedPeerGroupId]
    );

    const addCompany=()=>{

    };

    if (props.selectedPeerGroupId > 0) {
        return (
            <>
                <div className='formSubSelect'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Add Company</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedCompany}
                            label="Add Company"
                            onChange={(e) => (setSelectedCompany(e.target.value))}
                        >
                            <MenuItem value='0' key='0'>Select Company</MenuItem>
                            {

                                allCompanies.map((ele) => {
                                    if (ele.peerGroupId === null)
                                        return <MenuItem value={ele.companyId} key={ele.companyId}>{ele.companyName}</MenuItem>
                                })
                            }

                        </Select>
                    </FormControl>
                    
                </div>

                <Button variant="contained" onClick={addCompany}>Add Company</Button>  
            </>
        );
    }
    return (
        <>

        </>
    )
}

export default PeerAssignment2;